/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { BalancerExternalTokenRouter } from "../BalancerExternalTokenRouter";

export class BalancerExternalTokenRouter__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<BalancerExternalTokenRouter> {
    return super.deploy(
      overrides || {}
    ) as Promise<BalancerExternalTokenRouter>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BalancerExternalTokenRouter {
    return super.attach(address) as BalancerExternalTokenRouter;
  }
  connect(signer: Signer): BalancerExternalTokenRouter__factory {
    return super.connect(signer) as BalancerExternalTokenRouter__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BalancerExternalTokenRouter {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as BalancerExternalTokenRouter;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address[]",
        name: "bpAddresses",
        type: "address[]",
      },
      {
        indexed: true,
        internalType: "uint256[]",
        name: "bpAmounts",
        type: "uint256[]",
      },
    ],
    name: "UnderlyingTokensDeposited",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolAddress",
        type: "address",
      },
    ],
    name: "addPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "allTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensIn",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsIn",
        type: "uint256[]",
      },
    ],
    name: "estimateDeposit",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
    ],
    name: "estimateWithdraw",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pools",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokensOut",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amountsOut",
        type: "uint256[]",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
